import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import FormatListBulletedRoundedIcon from "@mui/icons-material/FormatListBulletedRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import DropDown from "./DropDown";

const steps = [
  { number: "1", text: "מפרסמים עבודה" },
  { number: "2", text: "בעלי מקצוע מציעים מחיר" },
  { number: "3", text: "בודקים ומחליטים אם להתקדם" },
];

const filterButtonSx = {
  minHeight: 40,
  px: 1.5,
  borderRadius: "11px",
  fontFamily: "Assistant",
  fontWeight: 800,
  textTransform: "none",
  "& .MuiButton-startIcon": { ml: 0.6, mr: 0 },
};

function BidTop({ showFilters, handleEnding, handleNewlyListed, handleAll, activeView, filter, setFilter, hideIntro = false }) {
  return (
    <Box dir="rtl" sx={{ mb: { xs: 2.5, md: 3 } }}>
      {!hideIntro && (
        <Box sx={{ position: "relative", overflow: "hidden", px: { xs: 1.5, sm: 2.5, md: 3 }, py: { xs: 2, md: 2.4 }, borderRadius: { xs: "20px", md: "24px" }, background: "linear-gradient(135deg, #0B67C2 0%, #238ADD 66%, #49A7EE 100%)", color: "#FFFFFF", boxShadow: "0 14px 34px rgba(21, 93, 157, .15)" }}>
          <Box sx={{ position: "absolute", width: 170, height: 170, borderRadius: "50%", bgcolor: "rgba(247,157,36,.95)", top: -112, right: -54 }} />
          <Box sx={{ position: "relative", zIndex: 1 }}>
            <Typography component="h2" sx={{ fontFamily: "Assistant", fontWeight: 900, textAlign: "center", fontSize: { xs: "1.45rem", sm: "1.75rem" }, mb: 1.6 }}>
              כך זה עובד ב-<Box component="span" sx={{ color: "#FFD18B", font: "inherit" }}>Bidit</Box>
            </Typography>

            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: { xs: 1, sm: 1.2 } }}>
              {steps.map((step) => (
                <Box key={step.number} sx={{ display: "flex", alignItems: "center", gap: 1, minHeight: { xs: 48, sm: 70 }, px: 1.3, py: 0.9, borderRadius: "15px", bgcolor: "rgba(255,255,255,.12)", border: "1px solid rgba(255,255,255,.2)" }}>
                  <Box sx={{ width: 28, height: 28, flexShrink: 0, display: "grid", placeItems: "center", borderRadius: "50%", bgcolor: "#FFFFFF", color: "#116FBA", fontFamily: "Assistant", fontWeight: 900 }}>
                    {step.number}
                  </Box>
                  <Typography sx={{ fontFamily: "Assistant", fontWeight: 800, fontSize: { xs: 14, md: 15 }, lineHeight: 1.35 }}>
                    {step.text}
                  </Typography>
                </Box>
              ))}
            </Box>

            <Typography sx={{ mt: 1.4, textAlign: "center", fontFamily: "Assistant", fontWeight: 700, fontSize: { xs: 13, sm: 14 }, color: "rgba(255,255,255,.92)" }}>
              ההצעות מדורגות לפי המחיר, ובסיום בוחנים את ההצעה המובילה ואת כרטיס בעל המקצוע.
            </Typography>
          </Box>
        </Box>
      )}

      {showFilters && (
        <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "stretch", md: "center" }} justifyContent="space-between" gap={1.4} sx={{ mt: 2, p: { xs: 1.2, md: 1.4 }, borderRadius: "18px", bgcolor: "#FFFFFF", border: "1px solid #E4EDF5", boxShadow: "0 8px 24px rgba(28,74,110,.06)" }}>
          <DropDown setFilter={setFilter} filter={filter} />
          <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 0.7 }}>
            <Button startIcon={<FormatListBulletedRoundedIcon />} onClick={handleAll} variant={activeView === "all" ? "contained" : "text"} sx={filterButtonSx}>הכל</Button>
            <Button startIcon={<AccessTimeRoundedIcon />} onClick={handleEnding} variant={activeView === "ending" ? "contained" : "text"} sx={filterButtonSx}>מסתיימים בקרוב</Button>
            <Button startIcon={<AutoAwesomeRoundedIcon />} onClick={handleNewlyListed} variant={activeView === "new" ? "contained" : "text"} sx={filterButtonSx}>חדשים</Button>
          </Box>
        </Stack>
      )}
    </Box>
  );
}

export default BidTop;
